import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { ProductUpdatePcm } from "api/memberPortal/product/productUpdate/productUpdate.types";
import {
  useDeleteProductUpdatePcmMutation,
  useListProductUpdatesPcmQuery,
  useUpdateProductUpdatePcmMutation,
} from "api/memberPortal/product/productUpdate/productUpdatePcm.api";

import { buildProductUpdateColumns } from "./components/updateTable/ProductUpdates.columns";
import ProductUpdatesBase from "./ProductUpdatesBase.screen";

const EMPTY_ARRAY: ProductUpdatePcm[] = [];

const PcmUpdates = () => {
  const { id: parentId } = useParams();

  const [triggerDelete] = useDeleteProductUpdatePcmMutation();
  const [triggerUpdate] = useUpdateProductUpdatePcmMutation();

  const updateQueryParam = parentId ? { parentId } : skipToken;
  const { data: productUpdates = EMPTY_ARRAY, isLoading } =
    useListProductUpdatesPcmQuery(updateQueryParam);

  const columns = useMemo(
    () =>
      buildProductUpdateColumns<ProductUpdatePcm>({
        onArchive: triggerDelete,
        onUnarchive: triggerUpdate,
        getParentId: (productUpdate) => productUpdate.pcm,
      }),
    [triggerDelete, triggerUpdate],
  );

  return (
    <ProductUpdatesBase
      productUpdates={productUpdates}
      isLoading={isLoading}
      columns={columns}
    />
  );
};
export default PcmUpdates;
